/**
 * Dark "blueprint" feature card: icon chip + index, title, copy, and an
 * accent rule that extends on hover. Used for the About page pillars.
 */
export function FeatureCard({ Icon, index, title, text, testId }) {
  return (
    <div
      data-testid={testId}
      className="group relative h-full overflow-hidden rounded-2xl border border-slate-800 bg-steel p-8 text-white blueprint-grid transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-royal/20"
    >
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-royal/30 blur-3xl transition-colors duration-500 group-hover:bg-royal/50"
        aria-hidden="true"
      />
      <div className="relative flex items-start justify-between">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-royal/40 bg-royal/15 text-royal-bright">
          <Icon className="h-6 w-6" aria-hidden="true" />
        </span>
        <span className="font-mono-sub text-xs font-semibold tracking-widest text-slate-500">
          0{index}
        </span>
      </div>
      <h3 className="relative mt-10 font-poster text-xl font-bold leading-snug">{title}</h3>
      <p className="relative mt-3 text-sm leading-relaxed text-slate-300">{text}</p>
      <span
        className="relative mt-8 block h-0.5 w-10 bg-royal-bright transition-[width] duration-500 group-hover:w-24"
        aria-hidden="true"
      />
    </div>
  );
}
